import { ExternalLink, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import PlatformLink from '@/components/common/PlatformLink';
import { Button } from '@/components/shadcn/button';
import { FieldDescription, FieldLabel } from '@/components/shadcn/field';

import useOutlookConnection, {
  getOutlookConnectionError,
} from '../queries/hooks/useOutlookConnection';

export default function OutlookSetting() {
  const { t } = useTranslation();
  const { data: outlook, isLoading } = useOutlookConnection();

  const connectionError = getOutlookConnectionError(outlook);

  return (
    <div className="flex flex-col gap-4 rounded-lg border p-2">
      <div>
        <FieldLabel>{t('OUTLOOK_CONNECT_TITLE')}</FieldLabel>

        <FieldDescription>{t('OUTLOOK_CONNECT_DESCRIPTION')}</FieldDescription>
      </div>

      {connectionError && (
        <div className="rounded bg-red-100 p-2 text-sm text-red-600 dark:bg-red-950 dark:text-red-300">
          {connectionError}
        </div>
      )}

      <Button asChild className="bg-[#0075DA] hover:bg-[#115EA3]">
        <PlatformLink to="/settings/connections/external" target="_blank">
          {isLoading && <Loader2 className="animate-spin" />}
          {!isLoading && outlook?.connected
            ? t('DISCONNECT_OUTLOOK_BUTTON')
            : t('CONNECT_OUTLOOK_BUTTON')}

          <ExternalLink />
        </PlatformLink>
      </Button>
    </div>
  );
}
